export const getUserImageUrl = (url?: string | null) => {
  if (!url) return "";

  if (/^(https?:)?\/\//.test(url) || url.startsWith("data:") || url.startsWith("blob:")) {
    return url;
  }

  const uploadsBaseUrl =
    process.env.REACT_APP_USER_UPLOADS_BASE_URL?.replace(/\/$/, "") ||
    "https://hiviewer-user-uploads.s3.eu-central-1.amazonaws.com";
  const apiBaseUrl = process.env.REACT_APP_MAIN_URL?.replace(/\/$/, "") || "";
  const imagePath = url.startsWith("/") ? url : `/${url}`;
  const isUserUpload = imagePath.startsWith("/pictures/");

  return `${isUserUpload ? uploadsBaseUrl : apiBaseUrl}${imagePath}`;
};
